import { gql } from '@efficiently/client-core-graphql-models';

export const CREATE_TAGS = gql(`
	mutation CreateTags($tags: [TagInput!]!) {
		createTags(tags: $tags) {
			...TagFields
		}
	}
`);
